/*
    阻止请求
*/

interface Pending {
    [name: string]: boolean;
}

export default class Prevent {
    
    //未结束请求
    private _pending: Pending = {};

    //加锁
    public lock(name: string) {
        this._pending[name] = true;
    }

    //解锁
    public unlock(name: string) {
        if (this._pending[name]) {
            delete this._pending[name];
        }
    }

    //检查
    public check(name: string): boolean {
        return this._pending[name] ? true : false;
    }
}